import api from '@/api';
import { API_BASE_URL } from '..';
import { PageResult } from '@/core/request/PageResult';
import {
  InstallmentTag,
  InstallmentTagsCreateRequest,
  InstallmentTagsQueryFilter,
} from './InstallmentTags.type';

const BASE = `${API_BASE_URL}/financial/installment-tags`;

export default {
  async list(params?: InstallmentTagsQueryFilter) {
    const result = (await api.get(`${BASE}/list`, params)) as unknown;
    return result as PageResult<InstallmentTag>;
  },

  async create(obj: InstallmentTagsCreateRequest) {
    const result = (await api.post(BASE, obj, null)) as unknown;
    return result as InstallmentTag;
  },

  async update(params: InstallmentTag) {
    const { id, ...obj } = params;
    const result = (await api.put(`${BASE}/${id}`, obj, null)) as unknown;
    return result as InstallmentTag;
  },

  async remove(id: number) {
    const result = (await api.remove(`${BASE}/${id}`, {}, null)) as unknown;

    return result;
  },
};
